import { Incident } from '@silbo/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IncidentStepperLayout } from '../IncidentStepperLayout';
import { CommentStep } from '../steps/CommentStep';
import { DelayStep } from '../steps/DelayStep';
import { SupportStep } from '../steps/SupportStep';
import { UnassignmentStep } from '../steps/UnassignmentStep';

type NeedHelpValue = Partial<Pick<Incident, 'helpRequired' | 'delayInMinutes' | 'unassignmentRequested' | 'comment'>>;

export function NeedHelp({ onBack, onComplete }: { onBack: () => void; onComplete: (value: NeedHelpValue) => void }) {
  const { t } = useTranslation('patient-transport');

  const [value, setValue] = useState<NeedHelpValue>({});

  const [activeStep, setActiveStep] = useState(0);

  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return (
          <SupportStep value={value.helpRequired} onChange={(helpRequired) => setValue({ ...value, helpRequired })} />
        );
      case 1:
        return (
          <DelayStep
            value={value.delayInMinutes}
            onChange={(delayInMinutes) => setValue({ ...value, delayInMinutes })}
          />
        );
      case 2:
        return (
          <UnassignmentStep
            value={value.unassignmentRequested}
            onChange={(unassignmentRequested) => setValue({ ...value, unassignmentRequested })}
          />
        );
      default:
        return (
          <CommentStep value={value.comment} onChange={(comment) => setValue({ ...value, comment })} incident={value} />
        );
    }
  };

  const isCurrentStepValid =
    activeStep === 0
      ? value.helpRequired !== undefined
      : activeStep === 1
        ? value.delayInMinutes !== undefined
        : activeStep === 2
          ? value.unassignmentRequested !== undefined
          : true;

  return (
    <IncidentStepperLayout
      title={t('fareIncidents.NEED_HELP')}
      stepsLength={4}
      activeStep={activeStep}
      isCurrentStepValid={isCurrentStepValid}
      onPrevious={() => setActiveStep(activeStep - 1)}
      onNext={() => setActiveStep(activeStep + 1)}
      onBack={onBack}
      onComplete={() => onComplete(value)}
    >
      {renderStep()}
    </IncidentStepperLayout>
  );
}
